import { render } from "./ListOrders.vue?vue&type=template&id=6042ff80"
import script from "./ListOrders.vue?vue&type=script&lang=js"
export * from "./ListOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__